import React, { useEffect, useState } from "react";

function getNetworkLabel() {
  const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (!connection) return "";
  if (connection.saveData) return "Data saver is enabled.";
  const effectiveType = connection.effectiveType || "";
  if (effectiveType === "slow-2g" || effectiveType === "2g") {
    return "Your connection is very slow. Some updates may take longer than usual.";
  }
  if (effectiveType === "3g") {
    return "";
  }
  return "";
}

export default function ConnectionStatusBanner() {
  const [online, setOnline] = useState(typeof navigator !== "undefined" ? navigator.onLine : true);
  const [networkLabel, setNetworkLabel] = useState("");
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const update = () => {
      const isOnline = navigator.onLine;
      const label = getNetworkLabel();

      setOnline(isOnline);
      setNetworkLabel(label);

      // Reset dismissal when the network fully recovers so future issues will alert the user again
      if (isOnline && !label) {
        setDismissed(false);
      }
    };

    update();
    window.addEventListener("online", update);
    window.addEventListener("offline", update);

    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection && typeof connection.addEventListener === "function") {
      connection.addEventListener("change", update);
    }

    return () => {
      window.removeEventListener("online", update);
      window.removeEventListener("offline", update);
      if (connection && typeof connection.removeEventListener === "function") {
        connection.removeEventListener("change", update);
      }
    };
  }, []);

  // Hide UI if network is fully healthy or if user manually dismissed the banner
  if ((online && !networkLabel) || dismissed) return null;

  return (
    <div
      className={
        online
          ? "bg-amber-50 dark:bg-amber-950/80 border-b border-amber-200 dark:border-amber-800 text-amber-900 dark:text-amber-200 transition-colors"
          : "bg-red-50 dark:bg-red-950/80 border-b border-red-200 dark:border-red-800 text-red-900 dark:text-red-200 transition-colors"
      }
    >
      <div className="max-w-7xl mx-auto px-4 py-2 text-xs sm:text-sm flex items-center justify-between gap-2">
        <div className="flex-1 text-center">
          {online ? networkLabel : "It's Orrith, not you. You appear to be offline. We'll reconnect automatically."}
        </div>
        <button
          onClick={() => setDismissed(true)}
          className={`shrink-0 p-1 rounded-md transition-colors ${
            online
              ? "text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/60 active:bg-amber-200 dark:active:bg-amber-800"
              : "text-red-700 dark:text-red-300 hover:bg-red-100 dark:hover:bg-red-900/60 active:bg-red-200 dark:active:bg-red-800"
          }`}
          aria-label="Dismiss banner"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}